module.exports = __webpack_public_path__ + "img/search.5db39a28.svg";